import {
  Component,
  Input,
  OnDestroy,
  inject,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subject, Subscription, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { LocationRepository } from "../../../location/location.repository";
import { Location } from "../../../location/location.model";
import { locationKind } from "app/location/location-kind.const";
import { Bind } from "primeng/bind";
import { AutoComplete } from "primeng/autocomplete";
import { FormsModule } from "@angular/forms";
import { LocationIconComponent } from "../../location-icon/location-icon.component";
import { AutocompleteEmptyMessageComponent } from "../autocomplete-empty-message/autocomplete-empty-message.component";

@Component({
  selector: "app-location-multiselect",
  styleUrls: ["./location-multiselect.component.scss"],
  templateUrl: "./location-multiselect.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Bind,
    AutoComplete,
    FormsModule,
    LocationIconComponent,
    AutocompleteEmptyMessageComponent,
  ],
})
export class LocationMultiselectComponent implements OnDestroy {
  private locationRepository = inject(LocationRepository);

  public readonly locationChange = output<Location[]>();
  public readonly autocompleteChange = output<boolean>();
  @Input() public locations: Location[];
  public readonly appendTo = input<any>(undefined);
  public readonly disabled = input<boolean>(false);
  public readonly clearFiltersButton = input(false);
  @Input() public locationKindFilter = "";
  public readonly includeRoadTerminals = input(false);

  public selectedLocations: string;
  public locationKind = locationKind;
  public subscription = new Subscription();
  public locationList: Location[] = [];
  public readonly loading = signal(false);

  private searchTerm = new Subject<{ query: string; kinds: string }>();

  public constructor() {
    this.subscription.add(
      this.searchTerm
        .pipe(
          switchMap(({ query, kinds }) =>
            this.locationRepository
              .search(query, kinds)
              .pipe(catchError(() => of(null))),
          ),
        )
        .subscribe((locations: Location[] | null) => {
          this.locationList = locations ?? [];
          this.loading.set(false);
          this.autocompleteChange.emit(true);
        }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onLocationChange(event: Location[]) {
    //this.locations = event;
    this.locationChange.emit(this.locations);
    //this.searchQuery = "";
  }

  public getPlaceholder() {
    return "Please select location";
  }

  public setLocationKindFilter(filter: string) {
    this.locationKindFilter = filter;
  }

  public search(event: { originalEvent: KeyboardEvent; query: string }): void {
    const kinds = [
      locationKind.airport,
      locationKind.port,
      locationKind.railTerminal,
    ];
    if (this.includeRoadTerminals()) {
      kinds.push(locationKind.roadTerminal);
    }

    // new array reference opens the overlay so the loading message is visible
    this.locationList = [];
    this.loading.set(true);
    this.searchTerm.next({ query: event.query, kinds: kinds.join(",") });
  }
}
